export const BRAND_SWATCHES = ['#BC97F5', '#CE8FE0', '#F573BC', '#F0817E', '#FBC4CC', '#FBD46A'] as const;
export type BrandSwatch = (typeof BRAND_SWATCHES)[number];

/** Accepts #RGB or #RRGGBB (leading # optional) and normalises to lowercase #rrggbb. */
export function normalizeHexColor(input: string): string | null {
	const raw = input.trim().replace(/^#/, '');
	if (/^[0-9a-fA-F]{6}$/.test(raw)) {
		return `#${raw.toLowerCase()}`;
	}
	if (/^[0-9a-fA-F]{3}$/.test(raw)) {
		return `#${raw
			.toLowerCase()
			.split('')
			.map(c => c + c)
			.join('')}`;
	}
	return null;
}
